jQuery(document).ready(function($) {
    //console.log(redirect_url);
    var is_single_product;
    if($('body').hasClass('single-product')){
        is_single_product === true;
    }else{
        is_single_product === false;
    }

    // Validate & Perform AJAX login on form submit
    $("form#login").validate({
        submitHandler: function (form) {
            var rememberme = 0;
            if($('form#login #login-rememberme'). prop("checked") == true){
                 rememberme = 1;
            }else{
                 rememberme = 0;
            }

            $('form#login div.status').show().html(ajax_login_object.loadingmessage);
            $('form#login').addClass("loading");
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajax_login_object.ajaxurl,
                data: {
                    'action'    : 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
                    'username'  : $('form#login #username').val(),
                    'password'  : $('form#login #password').val(),
                    'security'  : $('form#login #security').val(),
                    'rememberme': rememberme
                },
                success: function (data) {
                    $('form#login').removeClass("loading");
                    $('form#login div.status').html(data.message);
                    if (data.loggedin == true) {
                        $('form#login').addClass("loading");
                        //document.location.href = ajax_login_object.redirecturl;
                        if(is_single_product === true){
                            //location.reload(ajax_login_object.redirecturl+'#review_form_wrapper');
                            location.reload(redirect_url+'#review_form_wrapper');
                        }else{
                            //location.reload(ajax_login_object.redirecturl);
                            location.reload(redirect_url);
                        }
                    }
                }
            });
        }
    });

    // Validate & Perform AJAX register on form submit

    $("form#register").validate({
        submitHandler: function (form) {
                /* at the time of registration , enter value of email id of user in newsletter form's email id field */
               $('form.mc4wp-form input[type=email]').val($('form#register #register-email-address').val());
            //$('form#register').on('submit', function (e) {
                $('form#register div.status').show().html(ajax_login_object.loadingmessage);
                $('.equalheights').matchHeight();
                $('form#register').addClass("loading");
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: ajax_login_object.ajaxurl,
                    data: {
                        'action'            : 'ajaxregister', //calls wp_ajax_nopriv_ajaxlogin
                        'userfname'         : $('form#register #first-name').val(),
                        'userlname'         : $('form#register #last-name').val(),
                        'registeruseremail' : $('form#register #register-email-address').val(),
                        'register_pwd_name' : $('form#register #register_password').val(),
                        'security'          : $('form#register #security').val()},
                    success: function (data) {
                        $('form#register').removeClass("loading");
                        /**
                         * If checkbox of mailchimp is checked in registartion form then submit mailchimp newsletter form
                        *****/
                        if(jQuery("#mc4wpsubscribe").attr("checked")=="checked"){
                            $('form.mc4wp-form').submit();
                        }
                        /*************/
                        $('form#register div.status').html(data.message);
                        $('.equalheights').matchHeight();
                        /**
                         * Provide timeout here , so that newsletter form can be submiited.
                        ***/
                       setTimeout(
                            function()
                            {
                                if (data.registered == true) {
                                    $('form#register').addClass("loading");
                                    //document.location.href = ajax_login_object.redirecturl;
                                    document.location.href = redirect_url;
                                }
                            },
                        500);
                    }
                });
            //});
        }
    });

});